import React, { useEffect, useRef, useState } from 'react'
import intl from 'react-intl-universal'

function useInterval (callback, delay) {
  const savedCallback = useRef()
  useEffect(() => {
    savedCallback.current = callback
  }, [callback])
  useEffect(() => {
    function tick () {
      savedCallback.current()
    }
    if (delay !== null) {
      const id = setInterval(tick, delay)
      return () => clearInterval(id)
    }
  }, [delay])
}

export default function RenderSeconds (props) {
  const [count, setCount] = useState(60)
  useInterval(() => {
    if (count > 0) {
      setCount(count - 1)
    } else {
      props.handleOnEndCount()
      // props.handleOnGetVerificationCode(false)
    }
  }, 1000)
  return (
    <div
      className={'registerClock'}>
      {count}{intl.get('Seconds')}
    </div>
  )
}
